import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, HostListener } from '@angular/core';

@Component({
  selector: 'app-modal-select-nps',
  templateUrl: './modal-select-nps.component.html',
  styleUrls: ['./modal-select-nps.component.scss']
})
export class ModalSelectNpsComponent {
  @Input() modalTitle: string = "";
  @Input() isMobile: boolean = false;
  @Input() theme: string = "silver";
  @Input() dataSet: any[] = new Array();
  @Input() columns: string[] = new Array();
  @Input() columnsToHide: string[] = new Array();
  @Input() columnsToShow: string[] = ['npsDescription', 'odMetric', 'wtMetric', 'odImperial', 'wtImperial', 'metricUom', 'imperialUom'];
  @Input() selectedRow: any;
  @Input() columnsToFilter: string[] = new Array();
  @Input() showDeleteSelection: boolean = false;

  @Output() onCloseModalNps: EventEmitter<any> = new EventEmitter();
  @Output() onConfirmModalNps: EventEmitter<any> = new EventEmitter();
  @Output() deleteSelection: EventEmitter<any> = new EventEmitter();

  rowToEmit: any;

  constructor() { }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.onCloseModalClick();
    }
  }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["dataSet"]) {
      this.dataSet = new Array();
      this.dataSet = changes["dataSet"].currentValue;
    }

    if (changes && changes["columns"]) {
      this.columns = new Array();
      this.columns = changes["columns"].currentValue;
    }

    if (changes && changes["columnsToHide"]) {
      this.columnsToHide = new Array();
      this.columnsToHide = changes["columnsToHide"].currentValue;
    }

    if (changes && changes["selectedRow"]) {
      this.selectedRow = changes["selectedRow"].currentValue;
      this.rowToEmit = undefined;
    }

    if (changes && changes["showDeleteSelection"]) {
      this.showDeleteSelection = changes["showDeleteSelection"].currentValue;
    }

    if (changes && changes["columnsToFilter"]) {
      this.columnsToFilter = new Array();
      this.columnsToFilter = changes["columnsToFilter"].currentValue;
    }
  }

  onConfirmModalClick() {
    if (!this.canConfirmSelection()) return;
    this.onConfirmModalNps.emit(this.rowToEmit);
  }

  onCloseModalClick() {
    this.onCloseModalNps.emit('');
  }

  rowClick(evt: any) {
    //this.selectedRow = evt;
    this.rowToEmit = evt;
  }

  onDeleteSelection() {
    this.deleteSelection.emit('');
  }

  hasSelectedRow(): boolean {
    return this.canConfirmSelection();
  }

  canConfirmSelection(): boolean {
    if (!this.rowToEmit || Object.keys(this.rowToEmit).length == 0) return false;
    return !this.isSameNpsSchedule(this.rowToEmit, this.selectedRow);
  }

  private isSameNpsSchedule(row: any, selectedRow: any): boolean {
    const rowId = this.getNpsScheduleId(row);
    const selectedRowId = this.getNpsScheduleId(selectedRow);

    if (!rowId || !selectedRowId) return false;
    return rowId === selectedRowId;
  }

  private getNpsScheduleId(row: any): string | null {
    const id = row?.npsScheduleId;
    return id == null || id === '' ? null : id.toString();
  }
}
